module.exports = __webpack_public_path__ + "img/mobile-reg-hse1.f9db88dd.png";